const { PAYMENT_TYPE } = require('./payment');

module.exports = {
    paymentTypeTitle(paymentTypeId) {
        switch(paymentTypeId) {
            case PAYMENT_TYPE.PRE_PAYMENT: return 'Предоплата';
            case PAYMENT_TYPE.POST_PAYMENT: return 'Постоплата';
            case PAYMENT_TYPE.PRE_POST_PAYMENT: return 'Предоплата и постоплата';
        }
        return '???';
    },
}